import React from "react";
import { Col, FormControl, FormGroup, FormLabel, Modal, Row } from "react-bootstrap";
import { ArrayHelper } from "../../helpers";
import WebFont from 'webfontloader';

interface Props {
  updateValue: (font: string) => void,
  onClose: () => void
}

export const DesignerFont: React.FC<Props> = props => {
  const [fonts, setFonts] = React.useState<{ category: string, family: string }[]>(null);
  const [category, setCategory] = React.useState("");
  const [search, setSearch] = React.useState("");

  const handleChange = (e: any) => {
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "category": setCategory(val); break;
      case "search": setSearch(val); break;
    }
  }

  const loadData = () => {
    const cached = sessionStorage.getItem("googleFonts");
    if (cached) {
      try {
        setFonts(JSON.parse(cached));
        return;
      } catch { /* fall through to fetch */ }
    }
    fetch("https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyBL-wa_2hoxdo8ujRSOBLA5bd0wCWX8VWg")
      .then(response => response.json())
      .then((data: any) => {
        const result: { category: string, family: string }[] = [];
        data.items.forEach((item: any) => { result.push({ family: item.family, category: item.category }) })
        try { sessionStorage.setItem("googleFonts", JSON.stringify(result)); } catch { /* quota — ignore */ }
        setFonts(result);
      })
      .catch(err => console.error("Failed to load Google fonts:", err));
  }

  const loadFonts = (fontList: { category: string, family: string }[]) => {
    const fonts: string[] = [];
    fontList.forEach(f => fonts.push(f.family));
    WebFont.load({
      google: { families: fonts }
    });
  }

  const getResults = () => {
    if (fonts) {
      let filtered: { category: string, family: string }[] = [...fonts];
      if (category) filtered = ArrayHelper.getAll(filtered, "category", category);
      if (search) filtered = ArrayHelper.getAllContaining(filtered, "family", search)
      const totalMatches = filtered.length;
      const cap = 30;
      if (filtered.length > cap) filtered.splice(cap, filtered.length - cap);
      loadFonts(filtered);

      const rows = filtered.map(f => (
        <tr key={f.family}>
          <td><a href="about:blank" onClick={(e) => { e.preventDefault(); props.updateValue(f.family); }} >{f.family}</a></td>
          <td style={{ fontFamily: f.family }}>The quick brown fox jumps over the lazy dog.</td>
        </tr>
      ));

      return (<>
        <table className="table table-sm">
          <thead>
            <tr><th>Name</th><th>Sample</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
        {totalMatches > cap && (
          <p className="description text-muted mb-0">Showing first {cap} of {totalMatches}. Refine the filter to narrow down.</p>
        )}
      </>);
    }
  }

  React.useEffect(loadData, []);

  return (
    <Modal id="designerFont" show={true} onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select a Font</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Category Filter</FormLabel>
              <FormControl as="select" id="category" onChange={handleChange}>
                <option value="">All</option>
                <option value="serif">Serif</option>
                <option value="sans-serif">Sans Serif</option>
                <option value="display">Display</option>
                <option value="handwriting">Handwriting</option>
                <option value="monospace">Monospace</option>
              </FormControl>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Search</FormLabel>
              <FormControl id="search" value={search} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
        {getResults()}

      </Modal.Body>
    </Modal>
  );

}